import { FormEvent, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, auth } from "../api";
import { queryClient } from "../main";
import { Card, Button, Field, Input } from "../components/ui";

interface TokenResponse {
  access_token: string;
}

interface LocationState {
  from?: { pathname: string };
}

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();
  const state = (loc.state ?? null) as LocationState | null;
  const nextParam = new URLSearchParams(loc.search).get("next");
  const from = state?.from?.pathname ?? nextParam ?? "/";

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const res = await api.post<TokenResponse>("/api/auth/login", { email, password });
      if (typeof res?.access_token !== "string" || !res.access_token) {
        throw new Error("Login response missing token");
      }
      auth.setToken(res.access_token);
      queryClient.clear();
      nav(from, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-canvas p-6">
      <Card className="w-full max-w-md">
        <div className="mb-6">
          <div className="grid h-10 w-10 place-items-center rounded-card bg-primary text-white font-bold mb-3">R</div>
          <h1 className="text-2xl font-semibold">Sign in</h1>
          <p className="text-sm text-muted">report-bot developer console.</p>
        </div>
        <form onSubmit={submit} className="space-y-4" noValidate>
          <Field label="Email">
            <Input
              type="email"
              value={email}
              autoComplete="email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Field>
          <Field label="Password">
            <Input
              type="password"
              value={password}
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Field>
          {error && (
            <div role="alert" aria-live="polite" className="text-sm text-danger">
              {error}
            </div>
          )}
          <Button type="submit" disabled={submitting} className="w-full">
            {submitting ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
